import React from 'react';
import { Icons } from '../../payloadNew/Icons';

// Steps factory for the SurveyResponse tour. Mirrors the PayloadNew tour copy
// verbatim, swapping "payload" → "survey/encuesta" depending on language, and
// keeps only the sections that exist on the survey page (no status, no
// location map, no insights, no PDF, no share). Steps whose target isn't
// present in the DOM are skipped automatically.

const HelpIcon = () => (
	<span className='ds-tour-inline-icon' aria-hidden='true'>
		<Icons.help />
	</span>
);

const getSurveyResponseSteps = (t) => [
	{
		target: '.pn-rail',
		title: t('tour.surveyResponse.rail.title'),
		body: t('tour.surveyResponse.rail.body'),
	},
	{
		target: '#pn-identity',
		title: t('tour.surveyResponse.identity.title'),
		body: t('tour.surveyResponse.identity.body'),
	},
	{
		target: '#pn-payload',
		title: t('tour.surveyResponse.payload.title'),
		body: t('tour.surveyResponse.payload.body'),
	},
	{
		target: '#pn-score',
		title: t('tour.surveyResponse.score.title'),
		body: (
			<>
				{t('tour.surveyResponse.score.bodyBefore')} <HelpIcon /> {t('tour.surveyResponse.score.bodyAfter')}
			</>
		),
	},
	{
		target: '#pn-content',
		title: t('tour.surveyResponse.content.title'),
		body: t('tour.surveyResponse.content.body'),
	},
];

export default getSurveyResponseSteps;
